export const WeaveRewindPrefixes = {
  DashboardCard: 'weave-rewind-dashboard-card',
  Modal: 'weave-rewind-modal',
  ProfileCard: 'weave-rewind-profile-card',
};
